import React, { Suspense, lazy, useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';

const FotoCarousel = lazy(() => import('./components/FotoCarousel'));
const MapsWithExplanations = lazy(() => import('./components/MapsWithExplanations'));
const ReviewGallery = lazy(() => import('./components/ReviewGallery'));
const Impressions = lazy(() => import('./components/Impressions'));

function DeferredSection({ children, minHeight = 320 }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || visible) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '300px 0px' }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [visible]);

  return (
    <section ref={ref} style={{ minHeight }}>
      {visible ? children : null}
    </section>
  );
}

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Main route with the header and other sections */}
        <Route
          path="/"
          element={
            <>
              <Header />
              <DeferredSection minHeight={720}>
                <Suspense fallback={<div style={{ minHeight: 720 }} />}>
                  <MapsWithExplanations />
                </Suspense>
              </DeferredSection>
              <DeferredSection minHeight={420}>
                <Suspense fallback={<div style={{ minHeight: 420 }} />}>
                  <ReviewGallery />
                </Suspense>
              </DeferredSection>
              <DeferredSection minHeight={560}>
                <Suspense fallback={<div style={{ minHeight: 560 }} />}>
                  <Impressions />
                </Suspense>
              </DeferredSection>
            </>
          }
        />
        <Route
          path="/fotos"
          element={(
            <Suspense fallback={<div style={{ padding: '40px', textAlign: 'center' }}>Foto&apos;s laden...</div>}>
              <FotoCarousel />
            </Suspense>
          )}
        />
      </Routes>
    </Router>
  );
};

export default App;
